import { Directive, input, TemplateRef } from '@angular/core';
import { ToolbarBridgeService } from './toolbar-bridge.service';

@Directive({
  selector: '[tpToolbarActions]',
})
export class ToolbarActions {
  toolbarId = input.required<string>();
  slot = input<string>('left');

  constructor(
    private templateRef: TemplateRef<unknown>,
    private bridge: ToolbarBridgeService,
  ) {}

  ngOnInit(): void {
    this.bridge.updateSlot(this.toolbarId(), this.slot(), this.templateRef);
  }

  ngOnDestroy(): void {
    this.bridge.updateSlot(this.toolbarId(), this.slot(), null);
  }
}
